//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PCI',
  data() {
    return {
      form: {
        item1: '',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '',
        item6: '0',
        item7: '0',
        item8: '0',
      },
      hasScore: false,
      disabled: false,
      title: '',
      text: '',
      item1List: [
        { value: '0', name: '<40' },
        { value: '1', name: '40~49' },
        { value: '2', name: '50~59' },
        { value: '3', name: '60~69' },
        { value: '4', name: '70~79' },
        { value: '5', name: '80~89' },
        { value: '6', name: '90~99' },
      ],
      item5List: [
        { value: '0', name: 'Ⅰ级或Ⅱ级' },
        { value: '2', name: 'Ⅲ级或Ⅳ级' },
      ]
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = form.item1 + form.item2 * 5 + form.item3 * 3 + form.item4 * 2 + form.item5 + form.item6 * 5 + form.item7 * 2 + form.item8 * 2
        if (res >= 0 && res <= 5) {
          self.title = '极低危'
          self.text = '<2'
        } else if (res >= 6 && res <= 8) {
          self.title = '低危'
          self.text = '2~5'
        } else if (res >= 9 && res <= 11) {
          self.title = '中危'
          self.text = '5~10'
        } else if (res >= 12 && res <= 14) {
          self.title = '高危'
          self.text = '10~25'
        } else if (res >= 15) {
          self.title = '极高危'
          self.text = '>25'
        }
        self.hasScore = true
        return String(res)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/PCI.vue